import(/* webpackMode: "eager" */ "/app/src/app/[locale]/auth/email-reset-password/page.tsx");
